import Link from '@components/common/Link/Link'
import { AccordionItemFragment } from '@lib/umbraco/generated/types.generated'
import clsx from 'clsx'
import { FC } from 'react'
import { Specification } from '../ProductSidebar/ProductSidebar'
import s from './Specifications.module.scss'

export type SpecificationsProps = {
  specifications: Specification[] | AccordionItemFragment[]
  type?: 'default' | 'special'
}

const Specifications: FC<SpecificationsProps> = ({
  specifications,
  type = 'default',
}) => {
  const processedSpecifications = specifications.map((spec) => {
    if ('itemLink' in spec) {
      // SpecificationWithLink logic
      return {
        label: spec.itemTitle,
        value: (
          <Link className={s.accordionLink} link={{ ...spec.itemLink }}>
            <span className={s.underlineAnimation}>{spec.itemTitle}</span>
          </Link>
        ),
      }
    } else {
      // Specification logic
      return {
        label: spec.label + ':',
        value: spec.value,
      }
    }
  })

  return type === 'default' ? (
    <ul>
      {processedSpecifications.map((spec, i) => (
        <li key={i} className={s.specItem}>
          <span className={s.label}>{spec.label}</span>
          <span className={s.value}>{spec.value}</span>
        </li>
      ))}
    </ul>
  ) : (
    <div className={s.specialWrapper}>
      {processedSpecifications.map((spec, i) => (
        <div key={i} className={clsx(s.specItem, s.special)}>
          <span className={s.specialValue}>{spec.value}</span>
        </div>
      ))}
    </div>
  )
}

export default Specifications
